import React, { useEffect, useState } from 'react'
import { Provider } from 'react-redux'
import store from './Store/store'
import { BrowserRouter } from 'react-router-dom'
import MainLayout from './Layouts/mainLayout'
import { ConfigProvider, theme } from 'antd'
import ErrorBoundary from './Config/ErrorResponce'
import ScrollToTopOnNavigation from './ScrollToTop'
// import AutoLogout from './Utils/AutomaticLogout'

const App: React.FC = () => {
    const [departmentId, setDepartmentId] = useState<number>(0)

    useEffect(() => {
        const getDepartmentId = (): void => {
            const clientDynCategoryId = Number(
                localStorage.getItem('departmetId')
            )
            setDepartmentId(clientDynCategoryId)
        }

        getDepartmentId()

        const handleStorageChange = (event: StorageEvent): void => {
            if (event.key === 'departmetId') {
                getDepartmentId()
            }
        }

        window.addEventListener('storage', handleStorageChange)

        const localStorageWatcher = (): void => {
            const originalSetItem = localStorage.setItem

            localStorage.setItem = function (key, value) {
                originalSetItem.apply(this, [key, value])

                if (key === 'departmetId') {
                    setDepartmentId(Number(value))
                }
            }
        }

        localStorageWatcher()

        return () => {
            window.removeEventListener('storage', handleStorageChange)
        }
    }, [])

    const bgColor =
        departmentId === 1
            ? '#F1F9FE'
            : departmentId === 17 || departmentId === 253
              ? '#E1E6F0'
              : '#F1F5F1'

    return (
        <Provider store={store}>
            <ConfigProvider
                theme={{
                    algorithm: theme.defaultAlgorithm,
                    token: {
                        colorPrimary: '#306BFF',
                        colorBgLayout: bgColor,
                    },
                }}
            >
                <ErrorBoundary>
                    <BrowserRouter>
                        <ScrollToTopOnNavigation />
                        <MainLayout />
                    </BrowserRouter>
                </ErrorBoundary>
            </ConfigProvider>
        </Provider>
    )
}

export default App
